import { httpCreate } from './http';
const http = httpCreate('/srv/screen-lottery');
export const screenLottery = {
	create(activityId, data) {
		return http.post(`/${activityId}`, data);
	},
	editor(lotteryId, data) {
		return http.put(`/${lotteryId}`, data);
	},
	delete(lotteryId) {
		return http.delete(`/${lotteryId}`);
	},
	open(lotteryId, awardCount) {
		return http.post(`/run/${lotteryId}/${awardCount}`);
	},
	getList(activityId, params) {
		return http.get(`/${activityId}`, { params });
	},

	addUser(activityId, data) {
		return http.post(`/user/${activityId}`, data);
	},
	getUserList(activityId, params) {
		return http.get(`/user/${activityId}`, { params });
	},
	deleteUsers(activityId, ids) {
		return http.delete(`/user/${activityId}`, { data: ids });
	},
	importUserList(activityId, data) {
		return http.post(`/user/import/${activityId}`, data);
	},
	mustWinUsers(lotteryId) {
		return http.get(`/target/${lotteryId}`);
	},
	changeCanWin(lotteryId, data) {
		return http.post(`/target/${lotteryId}`, data);
	},
	getByUser(activityId, params) {
		return http.get(`/user/getByUser/${activityId}`, { params });
	},
	getWinList(activityId, params) {
		return http.get(`/winner/list/${activityId}`, { params });
	},
    getCurrentWinners(lotteryId, params) {
        return http.get(`winner/lottery/lastTime/${lotteryId}`, { params })
    },
	winnerMark(ids) {
		return http.put('/winner/mark', ids);
	},
	blackList(blessId, params) {
		return http.get(`/blackList/${blessId}`, { params });
	},
	virtually(lotteryId, num) {
		return http.post(`/virtually/${lotteryId}/${num}`);
	},
	getVirtually(lotteryId) {
		return http.get(`/virtually/${lotteryId}`);
	},
	batch(blessId, phones) {
		return http.delete(`/batch/${blessId}`, { data: phones });
	},
	addBlack(blessId, data) {
		return http.post(`/addBlack/${blessId}`, { mobPhone: data });
	},
	upload(lotteryId, file) {
		return http.post(`/importBlack/${lotteryId}`, file);
	},
};
